import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { createPaginationLinks } from '@/helpers/pagination';
import Previous from './Previous';
import Next from './Next';
import styles from './Pagination.module.scss';

interface IPagination {
  pagesCount?: number;
  postName?: string;
  extraClassName?: string;
  defaultCurrentPage?: number;
}

const Pagination: FC<IPagination> = ({ pagesCount = 0, postName = 'rating', extraClassName, defaultCurrentPage }) => {
  const getClassName = () => (extraClassName ? `${styles.pagination} ${styles[`${extraClassName}`]}` : styles.pagination);

  if (!pagesCount || !postName) {
    return null;
  }

  const router = useRouter();

  const urlPage = router.asPath;
  const splitedPageNo = urlPage.split('=');
  const currentPageNo = defaultCurrentPage ? defaultCurrentPage : parseInt(splitedPageNo[splitedPageNo.length - 1] ?? 1) || 1;
  const paginationLinks = createPaginationLinks(currentPageNo, pagesCount);
  const firstPageLink = defaultCurrentPage ? `${urlPage.split('/read/')[0]}/read/` : urlPage.includes('page') ? urlPage.split('page')[0] : './';

  if (pagesCount < 2) {
    return <></>;
  }

  return (
    <div className={styles.bookPagination}>
      <div className={getClassName()}>
        <Previous currentPageNo={currentPageNo} postName={postName} firstPageLink={firstPageLink} />

        {paginationLinks.map((pageNo: number, index: number) => {
          const paginationLink = `/${postName}${pageNo}`;

          return 'number' === typeof pageNo ? (
            <span key={`id-${index}`}>
              {Number(currentPageNo) !== pageNo ? (
                <Link prefetch={false} href={pageNo === 1 ? firstPageLink : paginationLink} className={styles.pagination__link}>
                  {pageNo}
                </Link>
              ) : (
                <span className={styles.active}>{pageNo}</span>
              )}
            </span>
          ) : (
            <span key={`id-${index}`}>{pageNo}</span>
          );
        })}

        <Next currentPageNo={currentPageNo} pagesCount={pagesCount} postName={postName} />
      </div>
    </div>
  );
};

export default Pagination;
